module.exports = __webpack_public_path__ + "static/img/logoB.3d4e8bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/header/logoB.png
// module id = JIxx
// module chunks = 1